//
//
//
//
//
//
//
//
//
//

import CollectionItem from "./collectionItem.vue";

export default {
  name: "Collections",
  created() {},
  props: {
    collections: Array
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
  components: {
    CollectionItem
  }
};



// WEBPACK FOOTER //
// ./src/components/collection/collections.vue